export const FETCH_CIRCUIT_CONFIGURATIONS = "FETCH_CIRCUIT_CONFIGURATIONS";
export const FETCH_CIRCUIT_CONFIGURATIONS_PENDING =
  "FETCH_CIRCUIT_CONFIGURATIONS_PENDING";
export const FETCH_CIRCUIT_CONFIGURATIONS_REJECTED =
  "FETCH_CIRCUIT_CONFIGURATIONS_REJECTED";
export const FETCH_CIRCUIT_CONFIGURATIONS_FULFILLED =
  "FETCH_CIRCUIT_CONFIGURATIONS_FULFILLED";
